import { fireEvent, events, initClickEventListener } from './functions';
import {
   create_UUID,
   getSessionStorage,
   getUUID,
   setCookie,
   setSessionStorage,
} from './utils';
import { ANALYTIC_CONSTANT, CS_CID, CS_SID, CS_VID } from './constants';
import { fireLogWithSentry } from './sentry';
import { GLOBAL_DIMENSIONS } from './dimensions';
import { TrackEventTypes } from './interfaces';
import { setDefaultValues } from './main';

/**
 * event method with promise callback
 * @param {object} data
 */
export const trackEvent = (data: TrackEventTypes) => {
   if (!data) return;
   let sessionKey;
   let trackData;
   try {
      // pageName to be send by frontend in prop0
      // so that global dimensions can be differentiated for different pages
      sessionKey = data.prop0 || sessionKey || '';

      trackData = getSessionStorage(ANALYTIC_CONSTANT + sessionKey.toLowerCase()) || {};
      const globalData = trackData;

      // merging session and app data
      for (const key in data) {
         // adding only global dimensions in globalData
         if (Object.prototype.hasOwnProperty.call(GLOBAL_DIMENSIONS, key)) {
            globalData[key] = data[key];
         }
      }
      // also storing timeout in sessionStorage so that it's value can persist
      // and frontend doesn't need to send it in every call
      if (data['timeout']) globalData['timeout'] = data['timeout'];

      setSessionStorage(ANALYTIC_CONSTANT + sessionKey.toLowerCase(), globalData);
   } catch (error) {
      fireLogWithSentry(
         'index.ts-->trackEvent-->error occurred in clickstream sdk',
         error
      );
      trackData = {};
   }

   for (const key in data) if (data[key]) trackData[key] = data[key];
   trackData.ctaTs = new Date().getTime();
   events.push(trackData);
   fireEvent();
};

/**
 * init method to set default values for SDK
 * @param {boolean} allowClickEventListener
 */
export const init = (allowClickEventListener = false) => {
   const corelationId = create_UUID();
   getUUID(CS_VID); // for setting default value
   getUUID(CS_SID); // for setting default value
   setCookie(CS_CID, corelationId);
   setDefaultValues(corelationId);
   if (allowClickEventListener) initClickEventListener();
};
